import BottomNav from "../../../../containers/BottomNav";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import { aviatorGames } from "../../../../lib/data/aviatorGames.data";
import GamesSearchModal from "../../../components/GamesSearchModal";


const AviatorGames = () => {
  // Convert object to array
  const aviatorGamesArray = Object.values(aviatorGames);

  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <div className="prvdr-game-page">
           <div className="games-heading">
            <h3>Aviator Games</h3>
            <div className="d-none d-lg-block">
              <GamesSearchModal />
            </div>
          </div>
            <ul className="gamelisting aviatorgames">
              {aviatorGamesArray.length > 0 ? (
                aviatorGamesArray.map((game, idx) => (
                  <li key={`crashgame-${idx}`}>
                    <a href={game.href}>
                      <img src={game.imgUrl} alt={game.alt} />
                      <div className="GameName">{game.name}</div>
                    </a>
                  </li>
                ))
              ) : (
                <p>No games available for this category.</p>
              )}
            </ul>
        </div>
      </main>
    <BottomNav />
    </>
  );
};

export default AviatorGames;
